module.exports = __webpack_public_path__ + "static/media/about_us.1c28d4cb.jpg";